var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-instagram-main-feed-post" }, [
    _c("div", {
      staticClass: "post-message-text",
      domProps: { innerHTML: _vm._s(_vm.post.content) }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "action-buttons" }, [
      _c(
        "div",
        { staticClass: "action-button copy-button", on: { click: _vm.onCopy } },
        [
          _c("span", [_vm._v("Copy Post")]),
          _vm._v(" "),
          _c("InlineSvg", {
            staticClass: "icon-svg",
            attrs: { src: "/images/icons/ic-copy-white.svg" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }